<template>
  <div class="bg-grey-light-50 rounded-3xl py-12 px-6 text-center">
    <h3 class="text-grey-light-900 font-semibold text-lg mt-6 mb-2">Still need some help?</h3>
    <p class="text-grey-light-600 mb-6">Get in touch with someone from our team who will be able to assist.</p>
    <router-link :to="{ name: 'shopper-contact-us' }">
      <Button variant="secondary" size="lg" class="py-6">Talk to support</Button>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { Button } from '../ui/button';
</script>
